// HELPERS
import {createClassName} from "@helpers/utils";
import React from "react";

// CLASSES
// COMPONENTS
import ContentBox from "@components/ContentBox/ContentBox";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";

// OTHER
import fulfillment from "./CurrentSolutions.fulfillment";
import OptionsList from "../../../components/OptionsList/OptionsList.jsx";
import TextView from "../../../../../components/TextView/TextView.jsx";
import Select from "../../../../../components/Select/Select.jsx";
import SimpleTextField from "../../../components/SimpleTextField/SimpleTextField.jsx";
import TextField from "../../../../../components/TextField/TextField.jsx";
import NumberField from "../../../components/NumberField/NumberField.jsx";
import {loop} from "../../../../../helpers/utils.js";
import Button from "../../../../../components/Button/Button.jsx";
import IntroBackground from "../IntroBackground/IntroBackground.jsx";

export default class CurrentSolutions extends React.PureComponent
{
	state = _getInitialState.call(this);
	fields = _getFields.call(this);

	static saveHorizonValues = [
		{label: "Kortare än 3 år", value: "<3"},
		{label: "Minst 3 år", value: "3+"},
		{label: "Minst 4 år", value: "4+"},
		{label: "Minst 5 år", value: "5+"},
		{label: "6 till 10 år", value: "6-10"},
		{label: "Över 10 år", value: ">10"}
	];

	goalWhenOptions = [
		{
			value: "1",
			label: "1 år sedan"
		},
		{
			value: "2",
			label: "2 år sedan"
		},
		{
			value: "3",
			label: "3 år sedan"
		},
		{
			value: "4",
			label: "4 år sedan"
		},
		{
			value: "5",
			label: "5 år sedan"
		},
		{
			value: "6",
			label: "6 år sedan"
		},
		{
			value: "7",
			label: "7 år sedan"
		},
		{
			value: "8",
			label: "8 år sedan"
		},
		{
			value: "9",
			label: "9 år sedan"
		},
		{
			value: "9+",
			label: "Mer än 9 år sedan"
		}
	];

	static orientationValues = [
		{label: "Fonder: Indexförvaltning", value: "Fonder: Indexförvaltning"},
		{label: "Fonder: Globalförvaltning", value: "Fonder: Globalförvaltning"},
		{label: "Fonder: Tillväxtbolag", value: "Fonder: Tillväxtbolag"},
		{label: "Fonder: Värdebolag", value: "Fonder: Värdebolag"},
		{label: "Fonder: Utdelningsbolag", value: "Fonder: Utdelningsbolag"},
		{label: "Fonder: Onoterat", value: "Fonder: Onoterat"},
		{label: "Fonder: Mixfonder", value: "Fonder: Mixfonder"},
		{label: "Fonder: Energi", value: "Fonder: Energi"},
		{label: "Fonder: Teknik", value: "Fonder: Teknik"},
		{label: "Fonder: Övrigt", value: "Fonder: Övrigt"},
		{label: "Aktier", value: "Aktier"},
		{label: "Annat", value: "Annat"},
	];

	static accountValues = [
		{label: "ISK", value: "ISK"},
		{label: "Depå", value: "Depå"},
		{label: "Kapitalförsäkring", value: "Kapitalförsäkring"},
		{label: "Bankkonto", value: "Bankkonto"},
		{label: "Tjänstepension", value: "Tjänstepension"},
		{label: "Löpande tjänstepension", value: "Löpande tjänstepension"},
		{label: "Pensionsförsäkring", value: "Pensionsförsäkring"},
	];

	isFulfilled(state)
	{
		return fulfillment(state, this.state);
	}

	setCustomerState(customerState, callbackFn)
	{
		customerState = {...this.state.customerState, ...customerState};
		this.setState({
			customerState,
			isFulfilled: this.isFulfilled({customerState})
		}, () =>
		{
			this.props.setAppState({viewFulfilled: this.state.isFulfilled});
			if (callbackFn)
			{
				callbackFn();
			}
		});
	}

	componentDidMount()
	{
		const {props} = this;
		const {setAppState} = props;

		// Set navigation events
		setAppState({
			viewFulfilled: this.isFulfilled(),
			showValidationWarning: false,
			navigationButtons: {
				sharing: {},
				back: {},
				next: {
					onClick: () =>
					{
						if (this.state.isFulfilled === true)
						{
							return;
						}

						this.setState({hasFormValidationErrors: true});
						return setAppState({
							showValidationWarning: true
						});
					}
				}
			}
		});
	}

	changeCustomerInvestedItem = (index, fieldName, value) =>
	{
		const {customerState} = this.state;
		const changedSolutions = {...customerState.current_solutions};

		changedSolutions[index - 1] = {
			...changedSolutions[index - 1],
			[fieldName]: value,
		};

		this.setCustomerState({current_solutions: changedSolutions});
	};

	render()
	{
		const {customerState, readOnly} = this.state;
		const hasFormValidationErrors = !this.state.isFulfilled && this.state.hasFormValidationErrors;
		const classes = createClassName("Cob-view Cob-view2", {});

		const currentInvestments = [];
		for (let i = 1; i <= customerState.current_solutions_count; i++)
		{
			currentInvestments.push(
				<CustomerInvestedIn index={i}
				                    hasFormValidationErrors={hasFormValidationErrors}
				                    readOnly={readOnly}
				                    item={customerState.current_solutions[(i - 1)]}
				                    onChange={this.changeCustomerInvestedItem}/>
			);
		}

		return (
			<div className={classes}>
				<DefaultFields fields={this.fields}/>

				<ContentBox>
					<h2>Information om kundens befintliga lösning</h2>

					<div className="Cob-view2-fields">

						<div className={"with-info-box"}>
							<OptionsList
								style={{marginBottom: "0"}}
								type="radio"
								description={"Har kunden kännedom om hur nuvarande aktör tar betalt?"}
								name="radio_customer_knowledge_fees"
								value={customerState.radio_customer_knowledge_fees}
								options={[
									{
										label: "Nej",
										value: "no",
										checked: customerState.radio_customer_knowledge_fees === "no"
									},
									{
										label: "Ja",
										value: "yes",
										checked: customerState.radio_customer_knowledge_fees === "yes"
									}
								]}
								onChange={(checked, radio_customer_knowledge_fees) => this.setCustomerState({radio_customer_knowledge_fees})}
								readOnly={readOnly}
								validation={value => (value && value.length > 0) || false}
							/>
							<div className={"info-box"}>
								<strong>Så här ställer du frågan:</strong><br />
								Känner du till exakt hur din nuvarande aktör tar betalt?
							</div>
						</div>

						{customerState.radio_customer_knowledge_fees === "yes" && (
							<React.Fragment>
								<p className={"field-label with-previous"}>
									Information om hur nuvarande förvaltare tar betalt
								</p>
								<TextView
									name="customer_current_fees_details"
									label={`Fritext (${1800 - customerState.customer_current_fees_details.length} tecken kvar)`}
									value={customerState.customer_current_fees_details}
									maxLength={1800}
									validation={value => value.length > 0}
									resize="vertical"
									onChange={({target}) => this.setCustomerState({customer_current_fees_details: target.value})}
									fullWidth
									minHeight={250}
									highlightErrors={hasFormValidationErrors}
									readOnly={readOnly}
								/>
							</React.Fragment>
						)}

						<OptionsList
							style={{marginTop: "35px", marginBottom: "0"}}
							type="radio"
							description={"Kännedom om antal avgiftstyper?"}
							name="radio_customer_knows_types_of_fees"
							value={customerState.radio_customer_knows_types_of_fees}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: customerState.radio_customer_knows_types_of_fees === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: customerState.radio_customer_knows_types_of_fees === "yes"
								},
								{
									label: "Osäker",
									value: "uncertain",
									checked: customerState.radio_customer_knows_types_of_fees === "uncertain"
								}
							]}
							onChange={(checked, radio_customer_knows_types_of_fees) => this.setCustomerState({radio_customer_knows_types_of_fees})}
							readOnly={readOnly}
							validation={value => (value && value.length > 0) || false}
						/>

						<p className={"field-label"}>
							Placeringshorisont, totala portföljen
						</p>
						<Select name="checkbox_advice_savehoriz_tot"
						        label="Ange år"
						        selectedIndex={customerState.checkbox_advice_savehoriz_totIndex}
						        options={CurrentSolutions.saveHorizonValues}
						        onChange={(option, index) =>
						        {
							        this.setCustomerState({
								        checkbox_advice_savehoriz_tot: option.value,
								        checkbox_advice_savehoriz_totIndex: index
							        });
						        }}
						        readOnly={readOnly}
						/>
						<input type={"hidden"} name={"text_savehoriz_total"}
						       value={customerState.checkbox_advice_savehoriz_totIndex !== -1 ?
							       CurrentSolutions.saveHorizonValues[customerState.checkbox_advice_savehoriz_totIndex].label :
							       ""}/>

						<OptionsList
							style={{marginTop: "35px", marginBottom: "0"}}
							type="radio"
							description={"Har kunden möjlighet att, på ett enkelt sätt, utvärdera hur den nuvarande lösningen har presterat över tid?"}
							name="radio_customer_can_eval"
							value={customerState.radio_customer_can_eval}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: customerState.radio_customer_can_eval === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: customerState.radio_customer_can_eval === "yes"
								},
								{
									label: "Osäker",
									value: "uncertain",
									checked: customerState.radio_customer_can_eval === "uncertain"
								}
							]}
							onChange={(checked, radio_customer_can_eval) => this.setCustomerState({radio_customer_can_eval})}
							readOnly={readOnly}
							validation={value => (value && value.length > 0) || false}
						/>

						<p className={"field-label with-previous"}>
							Hur länge har kunden varit placerad i nuvarande lösning?
						</p>
						<div style={{maxWidth: "200px"}}>
							<NumberField
								name={"customer_current_time_invested"}
								label={"Ange i antal år"}
								unit=" år"
								value={customerState.customer_current_time_invested}
								validation={value => (value.length > 0 && value > 0 && value < 100)}
								onChange={({target}) => this.setCustomerState({customer_current_time_invested: target.value})}
								readOnly={readOnly}
							/>
						</div>

						<p className={"field-label with-previous"}>
							Hur beräknar kunden nettoresultatet av den nuvarande lösningen?
						</p>
						<TextView
							name="customer_current_eval_criteria"
							label={`Fritext (${1800 - customerState.customer_current_eval_criteria.length} tecken kvar)`}
							value={customerState.customer_current_eval_criteria}
							maxLength={1800}
							validation={value => value.length > 0}
							resize="vertical"
							onChange={({target}) => this.setCustomerState({customer_current_eval_criteria: target.value})}
							fullWidth
							minHeight={250}
							readOnly={readOnly}
						/>

						<p className={"field-label with-previous"}>
							Vad är det faktiska avkastningsresultatet sedan start?
						</p>
						<div style={{flexDirection: "row"}}>
							<SimpleTextField type="number"
							                 name={"customer_current_result"}
							                 placeholder="Ange i %"
							                 value={customerState.customer_current_result}
							                 textAlign="left"
							                 validation={value => value.length > 0}
							                 style={{width: "90px", marginRight: "5px"}}
							                 onChange={({target}) => this.setCustomerState({customer_current_result: target.value})}
							                 readOnly={readOnly}/>%
							<input type={"hidden"} name={""} value={""}/>
						</div>
						<p className={"Cob-OptionsList-miniNote"}>
							Totalt på alla investeringar som har diskuterats.
						</p>

						<p className={"field-label"}>
							Hur ofta träffas kunden och den nuvarande rådgivaren, och hur ser dessa möten ut?
						</p>
						<TextView
							name="customer_current_eval_meetings"
							label={`Fritext (${1800 - customerState.customer_current_eval_meetings.length} tecken kvar)`}
							value={customerState.customer_current_eval_meetings}
							maxLength={1800}
							validation={value => value.length > 0}
							resize="vertical"
							onChange={({target}) => this.setCustomerState({customer_current_eval_meetings: target.value})}
							fullWidth
							minHeight={250}
							readOnly={readOnly}
						/>

						<div className={"with-info-box"} style={{marginTop: "35px", marginBottom: "0"}}>
							<OptionsList
								style={{marginTop: "0", marginBottom: "0"}}
								type="radio"
								description={"Finns det dokumenterade målsättningar för den lösning kunden har idag?"}
								name="customer_current_goals"
								value={customerState.customer_current_goals}
								options={[
									{
										label: "Nej",
										value: "no",
										checked: customerState.customer_current_goals === "no"
									},
									{
										label: "Ja",
										value: "yes",
										checked: customerState.customer_current_goals === "yes"
									},
									{
										label: "Osäker",
										value: "uncertain",
										checked: customerState.customer_current_goals === "uncertain"
									}
								]}
								onChange={(checked, customer_current_goals) => this.setCustomerState({customer_current_goals})}
								readOnly={readOnly}
								validation={value => (value && value.length > 0) || false}
							/>
							<div className={"info-box"} style={{visibility: customerState.customer_current_goals.length > 0 && customerState.customer_current_goals !== "yes" ? "visible" : "hidden"}}>
								<strong>Så här reagerar du som rådgivare på att det inte finns några mål:</strong><br />
								Vad ser du för risker med att din nuvarande aktör utför val utan att veta vad ditt långsiktiga mål är?
							</div>
						</div>

						{customerState.customer_current_goals === "yes" && (
							<React.Fragment>
								<p className={"field-label with-previous"}>
									När satte kunden de nuvarande målsättningarna?
								</p>
								<Select
									name="customer_current_goals_when"
									label={"Välj"}
									selectedIndex={this.goalWhenOptions.map(c => c.value).indexOf(customerState.customer_current_goals_when)}
									options={this.goalWhenOptions}
									onChange={(option) =>
									{
										this.setCustomerState({customer_current_goals_when: option.value});
									}}
									highlightErrors={hasFormValidationErrors}
									readOnly={readOnly}
								/>

								<p className={"field-label with-previous"}>
									När nås målsättningarna som satts för befintliga lösningar givet
									samma avkastning som de genererat hittills?
								</p>
								<TextView
									name="customer_current_goals_reached"
									label={`Fritext (${1800 - customerState.customer_current_goals_reached.length} tecken kvar)`}
									value={customerState.customer_current_goals_reached}
									maxLength={1800}
									validation={value => value.length > 0}
									resize="vertical"
									onChange={({target}) => this.setCustomerState({customer_current_goals_reached: target.value})}
									fullWidth
									minHeight={250}
									highlightErrors={hasFormValidationErrors}
									readOnly={readOnly}
								/>
							</React.Fragment>
						)}

						<div className={"with-info-box with-margin"}>
							<div className={"inputs"}>
								<p className={"field-label"}>
									Finns det något som nuvarande aktör gör speciellt bra?
								</p>
								<TextView
									name="customer_current_advisor_positives"
									label={`Fritext (${1800 - customerState.customer_current_advisor_positives.length} tecken kvar)`}
									value={customerState.customer_current_advisor_positives}
									maxLength={1800}
									validation={value => value.length > 0}
									resize="vertical"
									onChange={({target}) => this.setCustomerState({customer_current_advisor_positives: target.value})}
									fullWidth
									minHeight={250}
									readOnly={readOnly}
								/>
							</div>
							<div className={"info-box"}>
								Ställ frågan om vad som är anledningen till att kunden fortfarande är kvar hos aktören.
							</div>
						</div>

						<p className={"field-label with-previous"}>
							Finns det något som kan bli bättre, som kunden är mindre nöjd med idag?
						</p>
						<TextView
							name="customer_current_advisor_improvements"
							label={`Fritext (${1800 - customerState.customer_current_advisor_improvements.length} tecken kvar)`}
							value={customerState.customer_current_advisor_improvements}
							maxLength={1800}
							validation={value => value.length > 0}
							resize="vertical"
							onChange={({target}) => this.setCustomerState({customer_current_advisor_improvements: target.value})}
							fullWidth
							minHeight={250}
							readOnly={readOnly}
						/>

						<OptionsList
							style={{marginTop: "35px", marginBottom: "0"}}
							type="radio"
							description={"Är kundens rådgivare investerad i samma lösning som kunden?"}
							name="radio_customer_advisor_invested"
							value={customerState.radio_customer_advisor_invested}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: customerState.radio_customer_advisor_invested === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: customerState.radio_customer_advisor_invested === "yes"
								}
							]}
							onChange={(checked, radio_customer_advisor_invested) => this.setCustomerState({radio_customer_advisor_invested})}
							readOnly={readOnly}
							validation={value => (value && value.length > 0) || false}
						/>

						<OptionsList
							style={{marginTop: "35px", marginBottom: "0"}}
							type="radio"
							description={"Är kundens kapitalförvaltare investerad i samma lösning som kunden?"}
							name="radio_customer_am_invested"
							value={customerState.radio_customer_am_invested}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: customerState.radio_customer_am_invested === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: customerState.radio_customer_am_invested === "yes"
								}
							]}
							onChange={(checked, radio_customer_am_invested) => this.setCustomerState({radio_customer_am_invested})}
							readOnly={readOnly}
							validation={value => (value && value.length > 0) || false}
						/>

						<p className={"field-label"}>
							Vad har kunden för befintliga lösningar idag?
						</p>

						{customerState.current_solutions_count === 0 && (
							<React.Fragment>
								<em>Lägg till en rad för varje lösning kunder har idag.</em>
							</React.Fragment>
						)}

						{currentInvestments}

						<div style={{flexDirection: "row"}}>
							<Button
								size="small"
								label="Ta bort sista raden"
								style={{marginRight: "15px"}}
								appearance={customerState.current_solutions_count === 0 ? "medium" : "danger"}
								disabled={customerState.current_solutions_count === 0}
								onClick={() => this.setCustomerState({current_solutions_count: customerState.current_solutions_count - 1})}
								filled
							/>

							<Button
								size="small"
								label="Lägg till ny rad"
								appearance={customerState.current_solutions_count === 15 ? "medium" : "primary"}
								disabled={customerState.current_solutions_count === 15}
								onClick={() => this.setCustomerState({current_solutions_count: customerState.current_solutions_count + 1})}
								filled
							/>
						</div>

						<p className={"field-label"}>
							Risknivå nuvarande lösning
						</p>

						<div className="numbers-with-colors">
							<OptionsList
								type="radio"
								name="radio_current_risk"
								value={customerState.radio_current_risk}
								highlightErrors={hasFormValidationErrors}
								options={[
									{
										label: "1",
										value: "1",
										checked: customerState.radio_current_risk === "1"
									},
									{
										label: "2",
										value: "2",
										checked: customerState.radio_current_risk === "2"
									},
									{
										label: "3",
										value: "3",
										checked: customerState.radio_current_risk === "3"
									},
									{
										label: "4",
										value: "4",
										checked: customerState.radio_current_risk === "4"
									},
									{
										label: "5",
										value: "5",
										checked: customerState.radio_current_risk === "5"
									},
									{
										label: "6",
										value: "6",
										checked: customerState.radio_current_risk === "6"
									},
									{
										label: "7",
										value: "7",
										checked: customerState.radio_current_risk === "7"
									},
								]}
								onChange={(checked, radio_current_risk) => this.setCustomerState({radio_current_risk})}
								style={{maxWidth: "unset"}}
								readOnly={readOnly}
								validation={value => (value && value.length > 0) || false}
							/>
							<input type={"hidden"} name={"radio_advice_currentportfolio_risk"} value={customerState.radio_current_risk} />
						</div>

						<div className={"with-info-box with-margin"}>
							<div className={"inputs"}>
								<p className={"field-label"}>
									Motivera risknivåns lämplighet i förhållande till nuvarande lösnings
									avkastning sedan start
								</p>
								<TextView
									name="customer_current_risk_motivation"
									label={`Fritext (${1800 - customerState.customer_current_risk_motivation.length} tecken kvar)`}
									value={customerState.customer_current_risk_motivation}
									maxLength={1800}
									validation={value => value.length > 0}
									resize="vertical"
									onChange={({target}) => this.setCustomerState({customer_current_risk_motivation: target.value})}
									fullWidth
									minHeight={250}
									readOnly={readOnly}
								/>
							</div>
							<div className={"info-box"}>
								Baserat på den relativt höga risknivån i jämförelse med den relativt låga avkastningen
								som du just nu får på lång sikt, hur går dina tankar kring det?
							</div>
						</div>
					</div>
				</ContentBox>
			</div>
		);
	}
}

// PRIVATE FUNCTIONS
function _getInitialState()
{
	const {customer, viewNo, hasFormValidationErrors, readOnly} = this.props;
	const seenViews = JSON.parse(localStorage.getItem(`SEEN_VIEWS_${btoa(customer.caseId)}`)) || [];
	const hasBeenSeen = (seenViews.includes(viewNo));

	// if it hasn't been seen add the view to local storage for the specific case
	if (customer.caseId && !hasBeenSeen)
	{
		localStorage.setItem(`SEEN_VIEWS_${btoa(customer.caseId)}`, JSON.stringify([...seenViews, viewNo]));
	}

	let newState = getViewInitialStateForCustomer(customer);
	newState.isFulfilled = this.isFulfilled(newState);
	newState.hasFormValidationErrors = hasBeenSeen || hasFormValidationErrors;
	newState.readOnly = readOnly;
	return newState;
}

export function getViewInitialStateForCustomer(customer)
{
	let newState = {
		isFulfilled: false,
		isLoading: true,
		lookupNotFound: false,
		fraudFlag: false,
		errorMessage: null,
		customerState: {
			current_solutions_count: 0,
			radio_customer_knowledge_fees: customer.getData("radio_customer_knowledge_fees", ""),
			customer_current_fees_details: customer.getData("customer_current_fees_details", ""),
			radio_customer_knows_types_of_fees: customer.getData("radio_customer_knows_types_of_fees", ""),
			radio_customer_can_eval: customer.getData("radio_customer_can_eval", ""),
			text_savehoriz_total: customer.getData("text_savehoriz_total", ""),
			customer_current_eval_criteria: customer.getData("customer_current_eval_criteria", ""),
			checkbox_advice_savehoriz_tot: customer.getData("checkbox_advice_savehoriz_tot", ""),
			customer_current_eval_meetings: customer.getData("customer_current_eval_meetings", ""),
			customer_current_result: customer.getData("customer_current_result", ""),
			customer_current_goals_reached: customer.getData("customer_current_goals_reached", ""),
			customer_current_advisor_positives: customer.getData("customer_current_advisor_positives", ""),
			customer_current_advisor_improvements: customer.getData("customer_current_advisor_improvements", ""),
			radio_customer_advisor_invested: customer.getData("radio_customer_advisor_invested", ""),
			radio_customer_am_invested: customer.getData("radio_customer_am_invested", ""),
			customer_current_goals: customer.getData("customer_current_goals", ""),
			customer_current_goals_when: customer.getData("customer_current_goals_when", ""),
			radio_current_risk: customer.getData("radio_current_risk", ""),
			customer_current_risk_motivation: customer.getData("customer_current_risk_motivation", ""),
			customer_current_time_invested: customer.getData("customer_current_time_invested", ""),

			checkbox_advice_savehoriz_totIndex: (
				customer.getData("checkbox_advice_savehoriz_tot") === "<1" ? 0 :
					customer.getData("checkbox_advice_savehoriz_tot") === "<3" ? 0 :
						customer.getData("checkbox_advice_savehoriz_tot") === "1-2" ? 0 :
							customer.getData("checkbox_advice_savehoriz_tot") === "3+" ? 1 :
								customer.getData("checkbox_advice_savehoriz_tot") === "4+" ? 2 :
									customer.getData("checkbox_advice_savehoriz_tot") === "5+" ? 3 :
										customer.getData("checkbox_advice_savehoriz_tot") === "4-6" ? 2 :
											customer.getData("checkbox_advice_savehoriz_tot") === "6-10" ? 4 :
												customer.getData("checkbox_advice_savehoriz_tot") === ">10" ? 5 :
													-1
			)
		}
	};

	// Translate legacy values into new equivalents
	if (newState.customerState.checkbox_advice_savehoriz_tot === "<1" ||
		newState.customerState.checkbox_advice_savehoriz_tot === "1-2")
	{
		newState.customerState.checkbox_advice_savehoriz_tot = "<3";
	}
	else if (newState.customerState.checkbox_advice_savehoriz_tot === "4-6")
	{
		newState.customerState.checkbox_advice_savehoriz_tot = "4+";
	}

	newState.customerState.current_solutions = [];
	for (let i = 1; i < 16; i++)
	{
		if (customer.getData("customer_current_row_account_" + i) !== "")
		{
			newState.customerState.current_solutions_count = i;
		}

		let item = {
			amount: customer.getData("customer_current_row_amount_" + i, ""),
			accountType: customer.getData("customer_current_row_account_" + i, ""),
			institution: customer.getData("customer_current_row_institute_" + i, ""),
			institutionOther: "",
			horizon: customer.getData("customer_current_row_horizon_" + i, ""),
			orientation: customer.getData("customer_current_row_focus_" + i, ""),
			orientationOther: "",
			movable: customer.getData("customer_current_row_movable_" + i, false),
		};

		let matchedInstitution = false;
		for (let i = 0; i < IntroBackground.helpCompanyOptions.length; i++)
		{
			if (item.institution === IntroBackground.helpCompanyOptions[i].label)
			{
				matchedInstitution = true;
				break;
			}
		}

		if (!matchedInstitution && item.institution.length > 0)
		{
			item.institutionOther = item.institution;
			item.institution = "Annat";
		}

		let matchedOrientation = false;
		for (let i = 0; i < CurrentSolutions.orientationValues.length; i++)
		{
			if (item.orientation === CurrentSolutions.orientationValues[i].label)
			{
				matchedOrientation = true;
				break;
			}
		}

		if (!matchedOrientation && item.orientation.startsWith("Fonder: "))
		{
			item.orientationOther = item.orientation.substring(item.orientation.indexOf(":") + 2);
			item.orientation = "Fonder: Övrigt";
		}

		if (!matchedOrientation && item.orientation.startsWith("Aktier: "))
		{
			item.orientationOther = item.orientation.substring(item.orientation.indexOf(":") + 2);
			item.orientation = "Aktier";
		}

		if (!matchedOrientation && item.orientation.startsWith("Annat: "))
		{
			item.orientationOther = item.orientation.substring(item.orientation.indexOf(":") + 2);
			item.orientation = "Annat";
		}

		newState.customerState.current_solutions.push(item);
	}

	return newState;
}

function _getFields()
{
	return [
		"radio_customer_knowledge_fees",
		"customer_current_fees_details",
		"radio_customer_knows_types_of_fees",
		"checkbox_advice_savehoriz_tot",
		"text_savehoriz_total",
		"radio_customer_can_eval",
		"customer_current_eval_criteria",
		"customer_current_result",
		"customer_current_eval_meetings",
		"customer_current_goals_reached",
		"customer_current_advisor_positives",
		"customer_current_advisor_improvements",
		"radio_customer_advisor_invested",
		"radio_customer_am_invested",
		"customer_current_goals",
		"customer_current_goals_when",
		"radio_current_risk",
		"customer_current_risk_motivation",
		"customer_current_time_invested",

		...(() =>
		{
			const returnValue = [];
			loop(16, i =>
			{
				returnValue.push("customer_current_row_account_" + i);
				returnValue.push("customer_current_row_amount_" + i);
				returnValue.push("customer_current_row_focus_" + i);
				returnValue.push("customer_current_row_focus_other_" + i);
				returnValue.push("customer_current_row_institute_" + i);
				returnValue.push("customer_current_row_movable_" + i);
				returnValue.push("customer_current_row_horizon_" + i);
			}, false, 1);
			return returnValue;
		})(),
	];
}

class CustomerInvestedIn extends React.PureComponent
{
	render()
	{
		const {index, readOnly, hasFormValidationErrors, item} = this.props;

		return <div className={"invested"}>
			<div className={"row"}>
				<div className={"item"}>
					<Select
						name={"customer_current_row_account_" + index}
						label={"Sparandeform"}
						selectedIndex={CurrentSolutions.accountValues.map(c => c.value).indexOf(item.accountType)}
						options={CurrentSolutions.accountValues}
						onChange={(option) => this.props.onChange(index, "accountType", option.value)}
						highlightErrors={hasFormValidationErrors}
						readOnly={readOnly}
					/>
				</div>
				<div className={"item"}>
					<Select
						name={"customer_current_row_institute_" + index}
						label={"Institut"}
						selectedIndex={IntroBackground.helpCompanyOptions.map(c => c.value).indexOf(item.institution)}
						options={IntroBackground.helpCompanyOptions}
						onChange={(option) => this.props.onChange(index, "institution", option.value)}
						highlightErrors={hasFormValidationErrors}
						readOnly={readOnly}
					/>
				</div>
				<div className={"item"}>
					<NumberField
						name={"customer_current_row_amount_" + index}
						label={"Belopp"}
						unit=" kr"
						value={item.amount}
						showSeparators={true}
						validation={value => (value.length > 0)}
						onChange={({target}) => this.props.onChange(index, "amount", target.value)}
						highlightErrors={hasFormValidationErrors}
						readOnly={readOnly}
					/>
				</div>
			</div>

			{(item.institution === "Annat" || item.institution === "Annan") && (
				<div className={"row"}>
					<div className={"item"}>
						&nbsp;
					</div>
					<div className={"item flex"}>
						<TextField
							value={item.institutionOther}
							label="Ange institut"
							validation={value => value.length > 0 && value.length <= 40}
							onChange={({target}) => this.props.onChange(index, "institutionOther", target.value)}
							highlightErrors={hasFormValidationErrors}
							readOnly={readOnly}
						/>

						<input type={"hidden"} name={"customer_current_row_institute_" + index}
						       value={item.institutionOther}/>
					</div>
				</div>
			)}

			<div className={"row"}>
				<div className={"item"}>
					<Select
						name={"customer_current_row_horizon_" + index}
						label={"Placeringshorisont"}
						selectedIndex={CurrentSolutions.saveHorizonValues.map(c => c.label).indexOf(item.horizon)}
						options={CurrentSolutions.saveHorizonValues}
						onChange={(option) => this.props.onChange(index, "horizon", option.label)}
						highlightErrors={hasFormValidationErrors}
						readOnly={readOnly}
					/>
					<input type={"hidden"} name={"customer_current_row_horizon_" + index} value={item.horizon}/>
				</div>
				<div className={"item flex"}>
					{item.accountType !== "Bankkonto" && (
						<Select
							name={"customer_current_row_focus_" + index}
							label={"Placeringsinriktning"}
							selectedIndex={CurrentSolutions.orientationValues.map(c => c.value).indexOf(item.orientation)}
							options={CurrentSolutions.orientationValues}
							onChange={(option) => this.props.onChange(index, "orientation", option.value)}
							highlightErrors={hasFormValidationErrors}
							readOnly={readOnly}
						/>
					)}

					{item.accountType === "Bankkonto" && (
						<React.Fragment>
							&nbsp;
							<input type={"hidden"} name={"customer_current_row_focus_" + index} value={""} />
						</React.Fragment>
					)}

				</div>
			</div>

			{(item.orientation === "Fonder: Övrigt" ||
				item.orientation === "Aktier" ||
				item.orientation === "Annat") && (
				<div className={"row"}>
					<div className={"item"}>
						&nbsp;
					</div>
					<div className={"item flex"}>
						<TextField
							value={item.orientationOther}
							label="Specificera inriktning"
							validation={value => value.length > 0 && value.length <= 40}
							onChange={({target}) => this.props.onChange(index, "orientationOther", target.value)}
							highlightErrors={hasFormValidationErrors}
							readOnly={readOnly}
						/>
					</div>
					{item.orientation === "Fonder: Övrigt" && (
						<input type={"hidden"} name={"customer_current_row_focus_" + index}
						       value={"Fonder: " + item.orientationOther}/>
					)}
					{item.orientation !== "Fonder: Övrigt" && (
						<input type={"hidden"} name={"customer_current_row_focus_" + index}
						       value={item.orientation + ": " + item.orientationOther}/>
					)}
				</div>
			)}

			{(item.accountType === "Tjänstepension" ||
				item.accountType === "Löpande tjänstepension" ||
				item.accountType === "Pensionsförsäkring") && (
				<div className={"row"} style={{marginTop: "10px"}}>
					<div className={"item"}>
						<p>
							Tillgångarna är flyttbara?
						</p>
					</div>
					<div className={"item flex"}>
						<OptionsList
							name={"customer_current_row_movable_" + index}
							style={{marginTop: "0", marginBottom: "0"}}
							type="radio"
							value={item.movable}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: item.movable === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: item.movable === "yes"
								}
							]}
							onChange={(checked, movable) => this.props.onChange(index, "movable", movable)}
							highlightErrors={hasFormValidationErrors}
							readOnly={readOnly}
							validation={value => (value && value.length > 0) || false}
						/>
					</div>
				</div>
			)}
		</div>
	}
}